import { connect } from 'react-redux';
import { AppWrapper } from 'components/App/AppWrapper';
import { isAdminPortalSelector } from 'modules/app/selectors';

const mapStateToProps = (state: State.Root) => ({
  isAdminPortal: isAdminPortalSelector(state),
});

export const AppWrapperContainer = connect(mapStateToProps)(AppWrapper);
